<template>
  <div class="container-fluid">
    <div>
      <div class="row card">
        <div class="card-body" id="prof">
          <table v-if="dechargesLoaded" class="table">
            <thead style="background-color: #003667; color: white">
              <tr class="text-center">
                <td># Agresso</td>
                <td>Matricule RH</td>
                <td>Enseignant permanent</td>
                <td>Catégorie</td>
                <td>Collège</td>
                <td>Établissement</td>
                <td>Nombre d'heures</td>
                <td>Année universitaire</td>
                <td style="max-width: 100px">Commentaire</td>
                <td style="width: 100px">Status</td>
                <td>Date demande</td>
                <td>Date validation du doyen</td>
                <td>Date validation du VPAA</td>
              </tr>
            </thead>
            <tbody>
              <tr
                class="text-center"
                v-for="decharge in decharges"
                :key="`vac_${decharge.id}`"
              >
                <td>#{{ decharge.vacataire.agresso }}</td>
                <td>{{ decharge.vacataire.matricule_rh }}</td>
                <td>
                  {{ decharge.vacataire.nom }}
                  {{ decharge.vacataire.prenom }}
                </td>
                <td>{{ decharge.vacataire.categorie_prof }}</td>
                <td>{{ collegeNom(decharge) }}</td>
                <td>{{ etablissementNom(decharge) }}</td>
                <td>{{ decharge.nb_heures }} H</td>
                <td>{{ decharge.annee_universitaire }}</td>
                <td>{{ decharge.commentaire }}</td>
                <td>
                  <span
                    v-show="
                      decharge.status == 'en cours' ||
                      decharge.status == 'valide par doyen'
                    "
                    class="label label-xl label-info label-inline ml-3"
                  >
                    En cours
                  </span>
                  <span
                    v-show="decharge.status == 'valide par VPAA'"
                    class="label label-xl label-success label-inline ml-3"
                  >
                    Validé
                  </span>
                  <span
                    v-show="decharge.status == 'refusee'"
                    class="label label-xl label-danger label-inline ml-3"
                  >
                    Refusée
                  </span>
                </td>
                <td>{{ decharge.date_demande }}</td>
                <td>{{ decharge.date_validation_doyen }}</td>
                <td>{{ decharge.date_validation_VPAA }}</td>
              </tr>
              <tr v-show="!decharges.length">
                <td colspan="13" class="text-center">
                  Aucune décharge trouvé.
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="13">
                  <jw-pagination
                    :items="allDecharges"
                    @changePage="onChangePagedecharge"
                  ></jw-pagination>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      allDecharges: [],
      decharges: [],
      dechargesLoaded: null,
    };
  },
  computed: {
    config() {
      return {
        headers: {
          Authorization: "Bearer " + (this.user.api_token || ""),
        },
      };
    },
  },
  methods: {
    collegeNom(decharge) {
      return decharge.etablissement && decharge.etablissement.college
        ? decharge.etablissement.college.nom
        : "—";
    },
    etablissementNom(decharge) {
      return decharge.etablissement ? decharge.etablissement.nom : "—";
    },
    onChangePagedecharge(decharges) {
      this.decharges = decharges;
    },
    loadDecharges() {
      return axios
        .get("/api/get/vacataire/decharges", this.config)
        .then((res) => {
          this.allDecharges = res.data || [];
          this.dechargesLoaded = 1;
        })
        .catch(() => {
          this.allDecharges = [];
          this.decharges = [];
          this.dechargesLoaded = 1;
        });
    },
  },
  beforeMount() {
    this.loadDecharges();
  },
};
</script>
